import React from 'react'
import { useTranslation } from 'react-i18next';
import { PageError } from 'da-frontend-shared-ui-components/lib/Errors/PageError';

const NotFound = () => {
  const {t} = useTranslation()

  return <PageError title={t`errors.title`} description={t`errors.Not Found`} />;
};

export default NotFound;